import { SelectFilterPannelComponent } from './select-filter-pannel.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';

@NgModule({
  declarations: [SelectFilterPannelComponent],
  exports: [SelectFilterPannelComponent],
  entryComponents: [SelectFilterPannelComponent],
  imports: [CommonModule, FormsModule, AngularSvgIconModule, TranslateModule, ScrollbarModule]
})
export class SelectFilterPanelModule {}

export { SelectFilterPannelComponent };
